module.exports = __webpack_public_path__ + "img/banner5.ba174500.jpg";